import { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { Global, css } from "@emotion/react";


function CustomSpinner({ initialAnimation = 1 }) {
  const [showWipeout, setShowWipeout] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [currentAnimation, setCurrentAnimation] = useState(initialAnimation);
  const timeoutRefs = useRef([]);

  const clearAllTimeouts = () => {
    timeoutRefs.current.forEach(clearTimeout);
    timeoutRefs.current = [];
  };

  const addTimeout = (timeout) => {
    timeoutRefs.current.push(timeout);
    return timeout;
  };

  useEffect(() => {
    const startAnimation = () => {
      clearAllTimeouts();
      setShowWipeout(false);
      setCompleted(false);

      const initialDelay = currentAnimation === 1 ? 1900 : 3500;

      addTimeout(
        setTimeout(() => {
          setShowWipeout(true);
          addTimeout(
            setTimeout(() => {
              setCompleted(true);
              addTimeout(setTimeout(startAnimation, 3000));
            }, 1800)
          );
        }, initialDelay)
      );
    };

    startAnimation();
    return () => clearAllTimeouts();
  }, [currentAnimation]);

  const toggleAnimation = (animationNumber) => {
    if (currentAnimation !== animationNumber) {
      setCurrentAnimation(animationNumber);
    }
  };

  const gifFile = '/SlowLoader.gif';    //currentAnimation === 1 ? "/FastLoader.gif" : "/SlowLoader.gif";

  return (
    <>    <Global
    styles={css`
      @keyframes wipeOut {
        0% {
          transform: scale(1);
          opacity: 1;
        }
        100% {
          transform: scale(4);
          opacity: 0;
        }
      }
    `}
  />   
   <Box
  sx={{
    width: "100vw",
    height: "100vh",
    bgcolor: "transparent",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    position: "relative",
  }}
>
  {!completed && (
    <Box
      component="img"
      src={gifFile}
      alt="loader"
      sx={{
        width: "33%",
        objectFit: "contain",
        position: "relative",
        zIndex: 10,
      }}
    />
  )}

  {showWipeout && (
    <Box
      sx={{
        position: "absolute",
        width: 1000,
        height: 1000,
        borderRadius: "50%",
        bgcolor: "#41B3CB",
        animation: `wipeOut 1s linear forwards`,
        zIndex: 20,
      }}
    />
  )}
</Box></>

  );
}

export default CustomSpinner;
